<template>
  <el-drawer
    append-to-body
    custom-class="myDrawer"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :show-close="false"
    :wrapperClosable="false"
    :visible="visible"
    :size="autoSize"
    :modal="modal"
  >
    <template slot="title">
      <div>
        <div style="float: right">
          <slot name="header" />
        </div>
        <div>
          {{ title }}
          <slot name="header-extra" />
        </div>
      </div>
    </template>
    <div v-resize="checkResize" v-if="visible">
      <slot name="content" />
    </div>
  </el-drawer>
</template>

<style lang="less">
.myDrawer {
  // 滚动条的宽度
  ::-webkit-scrollbar {
    width: 0px !important;
    height: 16px !important;
  }

  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: #ddd !important;
  }

  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: #eee !important;
  }

  .el-drawer__header {
    margin-bottom: 0px !important;
    padding: 10px 15px 8px !important;
    border: 0px solid #ddd !important;
  }

  .el-drawer__body {
    -webkit-box-flex: 1 !important;
    -ms-flex: 1 !important;
    flex: 1 !important;
    overflow: auto !important;
  }
}
</style>

<script>
export default {
  data() {
    return {
      autoSize: "80%"
    };
  },
  props: {
    title: {
      type: String
    },
    leftSize: {
      type: Number
    },
    modal: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: Number
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean
    },
  },
  mounted() {
    this.checkResize();
  },
  created() {
    this.checkResize();
  },
  methods: {
    checkResize() {
      if (this.fullScreen) {
        this.autoSize = "100%";
        return;
      }
      let leftSize = this.leftSize || 0;
      let maxWidth = this.maxWidth || 500;
      try {
        let width = document.documentElement.clientWidth
          || document.body.clientWidth;
        if (width < maxWidth) {
          this.autoSize = "100%";
        } else {
          if (leftSize > 0) {
            this.autoSize = width - leftSize;
          } else {
            this.autoSize = maxWidth;
          }
        }
      } catch (error) { }
    },
  },
};
</script>